import React, { useState } from "react";
import PropTypes from "prop-types";
import SlideDrawer from "../common/SlideDrawer";
import Clickable from "../common/Clickable";
import SignersPanel from "./SignersPanel";
import MySignaturePanel from "./MySignaturePanel";
import PoAccessPanel from "./PoAccessPanel";

// Settings — Purchase Requisition / Purchase Order.
//  • My signature: mọi user (tạo/quản lý chữ ký qua Hub-Sign) — cần để ký phiếu.
//  • Signer settings: chỉ admin (site → Financial Controller / GM).
//  • PO access: chỉ admin (Department/User nào được xem TẤT CẢ Purchase Order — PR thì ai cũng xem được, không cần).
const PurchaseSignerSettingsModal = ({ show, onHide, isAdmin = false }) => {
  const [tab, setTab] = useState("signature");
  const active = !isAdmin ? "signature" : tab;

  const TABS = [
    { key: "signature", label: "My signature", icon: "bi-vector-pen" },
    ...(isAdmin ? [
      { key: "signers", label: "Signer settings", icon: "bi-person-check" },
      { key: "po-access", label: "PO access", icon: "bi-shield-lock" },
    ] : []),
  ];

  return (
    <SlideDrawer
      show={show}
      onHide={onHide}
      placement="bottom"
      height="90vh"
      fixedHeight
      bodyClassName="tw-bg-geist-bg-2"
      title={
        <div className="tw-flex tw-items-center tw-gap-2">
          <i className="bi bi-gear tw-text-geist-fg-3" />
          <span className="tw-text-base tw-font-bold tw-text-geist-fg">Purchase Requisition / Order — Settings</span>
        </div>
      }
    >
      {/* Tabs — chỉ hiện khi có nhiều hơn 1 (admin). */}
      {TABS.length > 1 && (
        <div className="tw-inline-flex tw-items-center tw-gap-1 tw-p-1 tw-mb-4 tw-rounded-geist-md tw-bg-geist-100">
          {TABS.map((t) => (
            <Clickable key={t.key} onClick={() => setTab(t.key)}
              className={`tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-rounded-[4px] tw-transition ${
                active === t.key ? "tw-bg-geist-bg tw-text-geist-fg tw-shadow-geist-card" : "tw-text-geist-fg-3 hover:tw-text-geist-fg"
              }`}>
              <i className={`bi ${t.icon} tw-text-[11px]`} /> {t.label}
            </Clickable>
          ))}
        </div>
      )}

      {active === "signers" ? <SignersPanel /> : active === "po-access" ? <PoAccessPanel /> : <MySignaturePanel />}
    </SlideDrawer>
  );
};

PurchaseSignerSettingsModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  isAdmin: PropTypes.bool,
};

export default PurchaseSignerSettingsModal;
